<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Medical Exam Certificate</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <fieldset>
        <div class="row">
            <div class="col-sm-6 mvd_form-group">
                <customer-search-bar label="Customer" (onItemSelected)="customerSelected($event)" (onItemRemoved)="removeCustomer()"></customer-search-bar>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <ng-container *ngIf="showEligibilityStatus">
                    <label>&nbsp;</label>
                    <div class="mvd_alert--message__info" *ngIf="eligibilityStatus == true"><i class="material-icons"></i>{{eligibilityMessage}}</div>
                    <div class="mvd_alert--message__warning" *ngIf="eligibilityStatus == false"><i class="material-icons"></i>{{eligibilityMessage}}</div>
                </ng-container>
                <ng-container *ngIf="null != tosExpiration && customer != null">
                    <label>Top of stack expiration</label>
                    <div class="mvd_form-control">{{ tosExpiration | date:'M/d/yyyy' }}</div>
                </ng-container>
                <ng-container *ngIf="customer != null">
                    <label>&nbsp;</label>
                    <div class="mvd_alert--message__warning" *ngIf="!!waiverStatus"><i class="material-icons"></i>{{waiverStatus}}</div>
                    <div class="mvd_alert--message__warning" *ngIf="!!dateReminder"><i class="material-icons"></i>{{dateReminder}}</div>
                </ng-container>
            </div>
        </div>
    </fieldset>
    <medical-exam-certificate [customerNumberId]="customer.customerNumber"
                              [createNewReport]="false"
                              [getEligibility]="true"
                              (formValidity)="formValidationStatus($event)"
                              (closeOuterModal)="close()"
                              (isSaving)="isSaving($event)"
                              (eligibility)="setEligibilityStatus($event)"
                              (waiverStatus)="showWaiverStatus($event)"
                              (dateReminder)="showDateReminder($event)"
                              *ngIf="!!customer">
    </medical-exam-certificate>
    <medical-exam-certificate-history [customerNumberId]="customer.customerNumber" *ngIf="customer != null"></medical-exam-certificate-history>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="close()">Cancel</button>
        <mvm-spinner-btn [isLoading]="saving" btnText="Save" [isDisabled]="true != isFormValid" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>